import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import ErrorBoundary from './component/error-boundary/ErrorBoundary';
import { initGlobalErrorHandlers } from './utils/globalErrorHandler';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { migrateLocalStorage } from './utils/localStorageMigration';

// Inicializa tratadores globais de erro
initGlobalErrorHandlers();

// Migra schema do localStorage antes de renderizar
migrateLocalStorage();

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  // <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  // </React.StrictMode> */}
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

serviceWorkerRegistration.register({
  onUpdate: (registration) => {
    window.dispatchEvent(new CustomEvent('sw-update', { detail: registration }));
  },
});
